import script from "./UsdtChargeList.vue?vue&type=script&setup=true&lang=js"
export * from "./UsdtChargeList.vue?vue&type=script&setup=true&lang=js"

import "./UsdtChargeList.vue?vue&type=style&index=0&id=5b4f19fe&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4f19fe"]])

export default __exports__